import { SingleMetricOptionMixin } from '../mixin';
import metricTranslatorMixin from '@/mixins/translator/metric';

import Chip from '../../components/Chip';

import * as C from '../../options/styles';

import MetricIcon from '@svgIcons/dashboard/metric.svg';

import { isValueExist } from '@/utils/utils';
import { IFRAME_EVENT_MESSAGE } from '@/utils/consts';
import { makeMetricFormat } from '../utils';

export default {
    name: 'SingleMetricOption',
    mixins: [SingleMetricOptionMixin, metricTranslatorMixin],
    props: {
        panelKey: String,
        currentList: {
            type: Array,
            default() {
                return [];
            },
        },
        canEditCustomMetric: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            iframeListeners_: [
                {
                    eventType: IFRAME_EVENT_MESSAGE.UPDATE_METRIC_PANEL,
                    listener: (e) => {
                        const { data } = e;
                        if (!data || data.panelKey !== this.panelKey) return;
                        const { selectedFields = [] } = data;

                        const updated = R.compose(
                            R.map(makeMetricFormat),
                            R.slice(0, 1)
                        )(selectedFields);
                        this.$emit('update', updated);
                    },
                },
            ],
        };
    },
    computed: {
        title() {
            return this.$t('FIELD_PANEL.metric.second_panel_title');
        },
        mainGuide() {
            return this.$t('FIELD_PANEL.metric.second_panel_main_guide');
        },
        subGuide() {
            return this.$t('FIELD_PANEL.metric.second_panel_sub_guide');
        },
        currentItem: R.compose(R.head, R.prop('currentList')),
    },
    methods: {
        renderItem() {
            const { currentItem } = this;

            if (!isValueExist(currentItem)) {
                return (
                    <C.ItemWrapper>
                        {this.renderNoList(
                            this.$t('EDITABLE_DASHBOARD.list_empty_metric')
                        )}
                    </C.ItemWrapper>
                );
            }

            const displayName =
                this.getFieldName(currentItem) ??
                this.getMetricName(currentItem);
            const status = this.getFieldStatus(currentItem);
            const isInvalid = status === C.ITEM_STATUS.INVALID;

            return (
                <C.ItemWrapper>
                    {this.wrapTooltip({
                        visible: isInvalid,
                        title: this.$t(
                            'EDITABLE_DASHBOARD.metric_no_longer_valid'
                        ),
                        content: (
                            <Chip
                                title={displayName}
                                status={status}
                                loading={this.fieldLabelsLoading}
                            />
                        ),
                    })}
                </C.ItemWrapper>
            );
        },
    },
    render() {
        const { wrapOptions, renderItem } = this;

        return (
            <C.ComponentWrapper>
                {wrapOptions({
                    children: renderItem(),
                    title: this.$t('NEW_DASHBOARD.order_of_columns'),
                    icon: <MetricIcon class="metric-icon" />,
                    loading: this.fieldLabelsLoading,
                })}
            </C.ComponentWrapper>
        );
    },
};
